module.exports = __webpack_public_path__ + "media/images/etyekilogo-apple-60x60-7711303c105b957e197c92d07e5b0e4d.png";